// ── USED EMOTO VALUATION ENGINE ──
// Used by homepage calculator, listing cards, listing detail pages, and sell-form pricing suggestions.

export const BIKES = {
  surron: {
    name: 'Sur-Ron',
    aliases: ['sur-ron', 'surron', 'sur_ron'],
    models: {
      'Light Bee X': {
        base: 3700,
        msrp: 4499,
        years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Most popular / widest parts support',
        aliases: ['light-bee', 'light bee', 'light bee x', 'lbx'],
      },
      'Light Bee S': {
        base: 3300,
        msrp: 4199,
        years: [2019, 2020, 2021, 2022, 2023, 2024],
        seg: 'trail',
        notes: '',
        aliases: ['light-bee-s', 'light bee s'],
      },
      'Ultra Bee': {
        base: 5400,
        msrp: 7199,
        years: [2022, 2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Mid-size — strong demand',
        aliases: ['ultra-bee', 'ultra bee'],
      },
      'Hyper Bee': {
        base: 6200,
        msrp: 8299,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: 'Newest model — very low used supply',
        aliases: ['hyper-bee', 'hyper bee'],
      },
      'Storm Bee': {
        base: 6800,
        msrp: 9799,
        years: [2021, 2022, 2023, 2024, 2025, 2026],
        seg: 'emoto',
        notes: 'Full-size MX class',
        aliases: ['storm-bee', 'storm bee'],
      },
    },
  },
  talaria: {
    name: 'Talaria',
    aliases: ['talaria'],
    models: {
      Sting: {
        base: 3100,
        msrp: 3999,
        years: [2020, 2021, 2022, 2023],
        seg: 'trail',
        notes: '',
        aliases: ['sting'],
      },
      'Sting R': {
        base: 3600,
        msrp: 4599,
        years: [2021, 2022, 2023, 2024],
        seg: 'mx',
        notes: '',
        aliases: ['sting-r', 'sting r'],
      },
      'Sting R MX3': {
        base: 3900,
        msrp: 4799,
        years: [2022, 2023, 2024],
        seg: 'mx',
        notes: '',
        aliases: ['mx3', 'sting-mx3', 'sting r mx3'],
      },
      'Sting R MX4': {
        base: 4100,
        msrp: 5199,
        years: [2023, 2024, 2025, 2026],
        seg: 'mx',
        notes: 'High demand',
        aliases: ['sting-mx4', 'sting r mx4', 'mx4', 'sting-r-mx4'],
      },
      'Sting MX5': {
        base: 4400,
        msrp: 4799,
        years: [2024, 2025, 2026],
        seg: 'mx',
        notes: 'Latest gen — limited used supply',
        aliases: ['mx5', 'sting-mx5', 'sting pro mx5', 'sting pro / mx5'],
      },
      XXX: {
        base: 3200,
        msrp: 3699,
        years: [2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Top-selling budget street/trail emoto',
        aliases: ['xxx', 'triple-x'],
      },
      Dragon: {
        base: 6500,
        msrp: 8499,
        years: [2024, 2025, 2026],
        seg: 'emoto',
        notes: 'Full-size MX',
        aliases: ['dragon'],
      },
    },
  },
  eride: {
    name: 'E-Ride Pro',
    aliases: ['eride', 'e-ride', 'e-ride-pro', 'e ride pro', 'erp'],
    models: {
      SS: {
        base: 3800,
        msrp: 4599,
        years: [2022, 2023, 2024],
        seg: 'mx',
        notes: '',
        aliases: ['ss', 'pro-ss', 'pro ss'],
      },
      'SS 2.0': {
        base: 4200,
        msrp: 4999,
        years: [2023, 2024, 2025, 2026],
        seg: 'mx',
        notes: '',
        aliases: ['ss-20', 'ss 2.0', 'ss2.0'],
      },
      'SS 3.0': {
        base: 4500,
        msrp: 4999,
        years: [2024, 2025, 2026],
        seg: 'mx',
        notes: 'Updated suspension gen',
        aliases: ['ss-30', 'ss 3.0', 'ss3.0'],
      },
      SR: {
        base: 4900,
        msrp: 5699,
        years: [2024, 2025, 2026],
        seg: 'emoto',
        notes: '25kW flagship',
        aliases: ['sr'],
      },
    },
  },
  altis: {
    name: 'Altis',
    aliases: ['altis'],
    models: {
      'Sigma MX': {
        base: 5100,
        msrp: 6199,
        years: [2024, 2025, 2026],
        seg: 'emoto',
        notes: '22kW MX class — top tier',
        aliases: ['sigma-mx', 'sigma mx'],
      },
      Sigma: {
        base: 4800,
        msrp: 5899,
        years: [2024, 2025, 2026],
        seg: 'emoto',
        notes: '22kW — strong reviews',
        aliases: ['sigma'],
      },
      Alpha: {
        base: 3600,
        msrp: 4499,
        years: [2022, 2023, 2024],
        seg: 'trail',
        notes: '',
        aliases: ['alpha'],
      },
      Delta: {
        base: 2900,
        msrp: 3599,
        years: [2023, 2024, 2025, 2026],
        seg: 'pit',
        notes: 'Entry pit-bike class',
        aliases: ['delta'],
      },
    },
  },
  stark: {
    name: 'Stark Future',
    aliases: ['stark', 'stark-future', 'stark future'],
    models: {
      Varg: {
        base: 8200,
        msrp: 11000,
        years: [2022, 2023, 2024],
        seg: 'emoto',
        notes: 'FIM championship-winning platform',
        aliases: ['varg'],
      },
      'Varg MX': {
        base: 9000,
        msrp: 11000,
        years: [2023, 2024, 2025, 2026],
        seg: 'emoto',
        notes: 'MX-spec flagship',
        aliases: ['varg-mx', 'varg mx'],
      },
      'Varg MX 1.2': {
        base: 9400,
        msrp: 11500,
        years: [2025, 2026],
        seg: 'emoto',
        notes: 'Latest spec — very few used',
        aliases: ['varg-mx-12', 'varg mx 1.2'],
      },
    },
  },
  rawrr: {
    name: 'Rawrr',
    aliases: ['rawrr'],
    models: {
      Mantis: {
        base: 3600,
        msrp: 4499,
        years: [2023, 2024],
        seg: 'trail',
        notes: 'Reverse system unique feature',
        aliases: ['mantis'],
      },
      'Mantis X': {
        base: 3100,
        msrp: 3599,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: 'Entry tier',
        aliases: ['mantis-x', 'mantis x'],
      },
      'Mantis X Pro': {
        base: 3900,
        msrp: 4699,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: '15kW upgraded version',
        aliases: ['mantis-x-pro', 'mantis x pro'],
      },
    },
  },
  bike79: {
    name: '79 Bike',
    aliases: ['79bike', 'bike79', '79 bike', '79-bike'],
    models: {
      Falcon: {
        base: 2900,
        msrp: 3599,
        years: [2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Lightest in class — 130 lb',
        aliases: ['falcon', 'falcon-m', 'falcon m'],
      },
      'Falcon Pro': {
        base: 3300,
        msrp: 3999,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: '10kW / 72V 35Ah',
        aliases: ['falcon-pro', 'falcon pro'],
      },
    },
  },
  segway: {
    name: 'Segway',
    aliases: ['segway', 'ninebot', 'segway / ninebot'],
    models: {
      X260: {
        base: 3400,
        msrp: 4999,
        years: [2020, 2021, 2022, 2023],
        seg: 'trail',
        notes: 'Sur-ron platform variant',
        aliases: ['x260', 'segway-x', 'x160 / x260'],
      },
      X160: {
        base: 2600,
        msrp: 3499,
        years: [2020, 2021, 2022],
        seg: 'trail',
        notes: 'Youth/entry chassis',
        aliases: ['x160'],
      },
    },
  },
  ventus: {
    name: 'Ventus',
    aliases: ['ventus'],
    models: {
      'One (V1)': {
        base: 4800,
        msrp: 5999,
        years: [2023, 2024],
        seg: 'emoto',
        notes: '28kW — popular tuner platform',
        aliases: ['one', 'v1', 'one (v1)'],
      },
      'One Plus (V1+)': {
        base: 5200,
        msrp: 6399,
        years: [2025, 2026],
        seg: 'emoto',
        notes: 'Upgraded suspension + brakes',
        aliases: ['one-plus', 'v1+', 'one plus (v1+)'],
      },
    },
  },
  dust: {
    name: 'Dust Moto',
    aliases: ['dust', 'dust-moto', 'dust moto'],
    models: {
      Hightail: {
        base: 8500,
        msrp: 10950,
        years: [2024, 2025, 2026],
        seg: 'emoto',
        notes: 'Premium US-developed — strong brand story',
        aliases: ['hightail'],
      },
    },
  },
  bonnell: {
    name: 'Bonnell',
    aliases: ['bonnell'],
    models: {
      '775 MX': {
        base: 4600,
        msrp: 5495,
        years: [2024, 2025, 2026],
        seg: 'mtb-mx',
        notes: 'e-MTB / MX hybrid',
        aliases: ['775-mx', '775 mx'],
      },
      '775 AM': {
        base: 3500,
        msrp: 4295,
        years: [2024, 2025, 2026],
        seg: 'mtb-mx',
        notes: 'All-mountain spec',
        aliases: ['775-am', '775 am'],
      },
      '805': {
        base: 7500,
        msrp: 9000,
        years: [2025, 2026],
        seg: 'emoto',
        notes: '30kW — just launched late 2025',
        aliases: ['805'],
      },
      '902': {
        base: 9000,
        msrp: 11000,
        years: [2025, 2026],
        seg: 'emoto',
        notes: '46kW flagship — very limited used',
        aliases: ['902'],
      },
    },
  },
  rfn: {
    name: 'RFN (Apollo)',
    aliases: ['rfn', 'rfn-apollo', 'apollo'],
    models: {
      Ares: {
        base: 2900,
        msrp: 3499,
        years: [2022, 2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: '74V — good range',
        aliases: ['ares'],
      },
      'Ares Rally': {
        base: 3200,
        msrp: 3899,
        years: [2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Rally-spec variant',
        aliases: ['ares-rally', 'ares rally'],
      },
      'Warrior Pro': {
        base: 2400,
        msrp: 2999,
        years: [2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Mid-tier',
        aliases: ['warrior-pro', 'warrior pro'],
      },
    },
  },
  arctic: {
    name: 'Arctic Leopard',
    aliases: ['arctic', 'arctic-leopard', 'arctic leopard'],
    models: {
      'XE Pro': {
        base: 4200,
        msrp: 5399,
        years: [2023, 2024],
        seg: 'trail',
        notes: 'Best range in class — 35 mi',
        aliases: ['xe-pro', 'xe pro'],
      },
      'XE Pro S': {
        base: 4600,
        msrp: 5599,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: 'Updated chassis — top trail pick 2025',
        aliases: ['xe-pro-s', 'xe pro s'],
      },
    },
  },
  electro: {
    name: 'Electro & Co',
    aliases: ['electro', 'electro-co', 'electro & co'],
    models: {
      'Model E1': {
        base: 3300,
        msrp: 4199,
        years: [2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Euro-rooted brand',
        aliases: ['e1', 'model-e1', 'model e1'],
      },
      'Model E2': {
        base: 3900,
        msrp: 4899,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: '',
        aliases: ['e2', 'model-e2', 'model e2'],
      },
    },
  },
  tori: {
    name: 'Tori',
    aliases: ['tori'],
    models: {
      'Tori T1': {
        base: 3200,
        msrp: 3999,
        years: [2023, 2024, 2025, 2026],
        seg: 'trail',
        notes: 'Newer brand',
        aliases: ['t1', 'tori-t1', 'tori t1'],
      },
      'Tori T2': {
        base: 3800,
        msrp: 4699,
        years: [2024, 2025, 2026],
        seg: 'trail',
        notes: '',
        aliases: ['t2', 'tori-t2', 'tori t2'],
      },
    },
  },
};

export const UPGRADES = [
  { id: 'suspension', label: 'Suspension Upgrade (fork/shock)', val: 380 },
  { id: 'battery', label: 'Battery Upgrade / Spare Pack', val: 520 },
  { id: 'controller', label: 'Controller Tune / Upgrade', val: 290 },
  { id: 'sprocket', label: 'Sprocket / Chain Drive Kit', val: 90 },
  { id: 'tires', label: 'Premium Tires (Kenda / Maxxis)', val: 130 },
  { id: 'brakes', label: 'Brake Upgrade (DOT / Formula)', val: 165 },
  { id: 'lights', label: 'Lighting / LED Kit', val: 95 },
  { id: 'plastics', label: 'Aftermarket Graphics / Plastics', val: 185 },
  { id: 'bars', label: 'Handlebar / Stem / Controls', val: 120 },
  { id: 'protection', label: 'Frame Guards / Skid Plate', val: 80 },
  { id: 'wheels', label: 'Upgraded Wheelset', val: 420 },
  { id: 'seat', label: 'Custom Seat / Comfort Upgrade', val: 75 },
];

export const CONDITION_OPTIONS = [
  { val: 1.14, score: '10', label: 'Like New', id: 'like-new' },
  { val: 1.0, score: '8', label: 'Excellent', id: 'excellent' },
  { val: 0.86, score: '6', label: 'Good', id: 'used-good' },
  { val: 0.72, score: '4', label: 'Fair', id: 'fair' },
  { val: 0.52, score: '2', label: 'Poor', id: 'for-parts' },
];

export function deprMult(age) {
  if (age <= 0) return 1.0;
  const curve = [1.0, 0.89, 0.79, 0.7, 0.63, 0.57];
  return curve[Math.min(age, 5)];
}

export function mileAdj(m) {
  if (!m || m < 50) return 0;
  if (m < 200) return -80;
  if (m < 500) return -200;
  if (m < 1000) return -400;
  if (m < 2000) return -650;
  return -950;
}

export function crashAdj(c) {
  const parsed = parseInt(c, 10);
  if (isNaN(parsed) || parsed < 0) return 0;
  return [0, -200, -600, -1400][Math.min(parsed, 3)];
}

/**
 * Battery cycle degradation adjustment.
 * E-moto lithium packs maintain strong resale within first ~100 cycles,
 * then experience typical capacity decline.
 */
export function batteryCycleAdj(cycles) {
  if (!cycles || cycles <= 50) return 0;
  if (cycles <= 150) return -50;
  if (cycles <= 300) return -150;
  if (cycles <= 500) return -350;
  return -600;
}

export function fmt(n) {
  return '$' + Math.round(n).toLocaleString();
}

/**
 * Normalizes user/category input to standard bike make key
 */
export function findBikeMakeKey(input) {
  if (!input) return null;
  const clean = String(input).trim().toLowerCase();

  for (const [key, bike] of Object.entries(BIKES)) {
    if (key === clean) return key;
    if (bike.name.toLowerCase() === clean) return key;
    if (bike.aliases && bike.aliases.some(a => a.toLowerCase() === clean)) {
      return key;
    }
  }
  return null;
}

/**
 * Finds model name in BIKES[makeKey] matching input string
 */
export function findBikeModelName(makeKey, input) {
  if (!makeKey || !BIKES[makeKey] || !input) return null;
  const models = BIKES[makeKey].models;
  const clean = String(input).trim().toLowerCase();

  for (const [modelName, mData] of Object.entries(models)) {
    if (modelName.toLowerCase() === clean) return modelName;
    if (mData.aliases && mData.aliases.some(a => a.toLowerCase() === clean)) {
      return modelName;
    }
  }

  // Substring match fallback (e.g. "mx4" inside "Sting R MX4")
  for (const [modelName, mData] of Object.entries(models)) {
    if (clean.includes(modelName.toLowerCase())) return modelName;
    if (mData.aliases && mData.aliases.some(a => clean.includes(a.toLowerCase()))) {
      return modelName;
    }
  }

  return null;
}

/**
 * Resolves numeric condition multiplier from various input shapes
 */
export function resolveConditionValue(condition) {
  if (typeof condition === 'number') return condition;
  if (!condition) return 1.0;
  const clean = String(condition).trim().toLowerCase();
  if (clean === 'new' || clean === 'like-new' || clean === 'like_new' || clean === '10') {
    return 1.14;
  }
  if (clean === 'excellent' || clean === '8') {
    return 1.0;
  }
  if (clean === 'used-good' || clean === 'good' || clean === '6') {
    return 0.86;
  }
  if (clean === 'used' || clean === 'fair' || clean === '4') {
    return 0.72;
  }
  if (clean === 'for-parts' || clean === 'poor' || clean === '2') {
    return 0.52;
  }
  return 1.0;
}

/**
 * Core estimation function.
 */
export function estimateBikeValue(params = {}) {
  const {
    make,
    model,
    year,
    condition = 1.0,
    mileage = 0,
    batteryCycles = 0,
    crash = '0',
    upgrades = [],
  } = params;

  const makeKey = findBikeMakeKey(make);
  if (!makeKey || !BIKES[makeKey]) return null;

  const modelName = findBikeModelName(makeKey, model);
  if (!modelName || !BIKES[makeKey].models[modelName]) return null;

  const bData = BIKES[makeKey].models[modelName];
  const modelYear = parseInt(year, 10) || 2024;
  const currentYear = 2026;
  const age = Math.max(0, currentYear - modelYear);
  const dm = deprMult(age);
  const base = bData.base;
  const afterDepr = base * dm;

  const condVal = resolveConditionValue(condition);
  const afterCond = afterDepr * condVal;

  const mAdj = mileAdj(parseInt(mileage, 10) || 0);
  const bAdj = batteryCycleAdj(parseInt(batteryCycles, 10) || 0);
  const cAdj = crashAdj(crash);

  let upgTotal = 0;
  const upgRows = [];
  const activeUpgradesSet = new Set(Array.isArray(upgrades) ? upgrades : []);

  UPGRADES.forEach(u => {
    if (activeUpgradesSet.has(u.id)) {
      const rec = Math.round(u.val * 0.58);
      upgTotal += rec;
      upgRows.push({ label: u.label, val: rec });
    }
  });

  const final = Math.max(Math.round(afterCond + mAdj + bAdj + cAdj + upgTotal), 300);
  const low = Math.round(final * 0.88);
  const high = Math.round(final * 1.12);

  let conf = 52;
  if ((parseInt(mileage, 10) || 0) > 0) conf += 12;
  if ((parseInt(batteryCycles, 10) || 0) > 0) conf += 8;
  if (upgRows.length) conf += 10;
  if (crash !== '0') conf += 5;
  conf = Math.min(conf, 88);

  const condLabels = {
    1.14: 'Like New',
    1.0: 'Excellent',
    0.86: 'Good',
    0.72: 'Fair',
    0.52: 'Poor',
  };

  const rows = [
    {
      label: `${modelYear} ${BIKES[makeKey].name} ${modelName} — base market value`,
      val: fmt(base),
      cls: 'bkNeu',
    },
    {
      label: `Depreciation (${age} yr${age !== 1 ? 's' : ''} · ${Math.round(dm * 100)}% retained)`,
      val: fmt(afterDepr - base),
      cls: afterDepr - base >= 0 ? 'bkPos' : 'bkNeg',
    },
    {
      label: `Condition — ${condLabels[condVal] || 'Normal'}`,
      val: fmt(afterCond - afterDepr),
      cls: afterCond - afterDepr >= 0 ? 'bkPos' : 'bkNeg',
    },
  ];

  const miles = parseInt(mileage, 10) || 0;
  if (miles > 0) {
    rows.push({
      label: `Mileage usage (${miles.toLocaleString()} mi)`,
      val: fmt(mAdj),
      cls: mAdj >= 0 ? 'bkPos' : 'bkNeg',
    });
  }

  const cycles = parseInt(batteryCycles, 10) || 0;
  if (cycles > 0) {
    rows.push({
      label: `Battery cycle degradation (${cycles} cycles)`,
      val: fmt(bAdj),
      cls: bAdj >= 0 ? 'bkPos' : 'bkNeg',
    });
  }

  if (cAdj < 0) {
    rows.push({ label: 'Crash / damage history', val: fmt(cAdj), cls: 'bkNeg' });
  }

  upgRows.forEach(u => {
    rows.push({
      label: `${u.label} (+58% resale recovery)`,
      val: '+' + fmt(u.val),
      cls: 'bkPos',
    });
  });

  rows.push({ label: 'Estimated Private Party Value', val: fmt(final), cls: 'bkTot' });

  const badges = [];
  if (age <= 1) badges.push({ text: 'Recent Model — High Demand', cls: 'badge-hot' });
  if (makeKey === 'stark') badges.push({ text: 'Race-Proven Platform', cls: 'badge-hot' });
  if (makeKey === 'dust') badges.push({ text: 'Premium US Brand', cls: 'badge-stable' });
  if (makeKey === 'bonnell' && (modelName === '805' || modelName === '902')) {
    badges.push({ text: 'Just Launched — Very Limited Used Supply', cls: 'badge-hot' });
  }
  if (bData.seg === 'emoto') badges.push({ text: 'Full-Size eMoto Class', cls: 'badge-stable' });
  if (condVal >= 1.0) badges.push({ text: 'Excellent Condition Premium', cls: 'badge-stable' });
  if (condVal <= 0.72) badges.push({ text: 'Below-Average Condition', cls: 'badge-soft' });
  if (parseInt(crash, 10) >= 2) {
    badges.push({ text: 'Damage History — Disclosed', cls: 'badge-disc' });
  }
  if (bData.notes) badges.push({ text: bData.notes, cls: 'badge-soft' });

  const tips = [];
  if (condVal >= 1.0) {
    tips.push('Your excellent condition is your biggest asset — mention it first in the listing headline.');
  }
  if (upgRows.length > 1) {
    tips.push('Itemize every upgrade with brand names and receipts. Buyers pay more when they can verify the spec.');
  }
  if (makeKey === 'surron' || makeKey === 'talaria') {
    tips.push('Post in r/Surron or r/Talaria — community-driven sales move faster than generic marketplaces.');
  }
  if (makeKey === 'stark') {
    tips.push('Stark buyers are premium — emphasize race-readiness and battery health records.');
  }
  if (age >= 3) {
    tips.push('Offer a fresh charge and any battery cycle/health documentation to ease buyer hesitation on an older unit.');
  }
  tips.push('List 6-9% above your floor to leave room for negotiation without leaving money on the table.');

  return {
    final,
    low,
    high,
    base,
    conf,
    rows,
    badges: badges.slice(0, 3),
    tips,
    formattedEstimate: fmt(final),
    formattedRange: `${fmt(low)} – ${fmt(high)}`,
    makeKey,
    modelName,
  };
}

/**
 * Extracts bike attributes from an API listing entity and returns valuation if available.
 */
export function getListingValuation(listing) {
  if (!listing) return null;
  const publicData = listing?.attributes?.publicData || {};

  const make =
    publicData.categoryLevel2 ||
    publicData.brand ||
    publicData.make ||
    null;

  const model =
    publicData.categoryLevel3 ||
    publicData.model ||
    null;

  if (!make || !model) return null;

  const year = publicData.modelYear || publicData.year;
  const condition = publicData.condition || publicData.partCondition;
  const mileage = publicData.odometerMiles || publicData.mileage || 0;
  const batteryCycles = publicData.batteryCycles || 0;

  return estimateBikeValue({
    make,
    model,
    year,
    condition,
    mileage,
    batteryCycles,
  });
}

/**
 * Partially masks VIN/Serial numbers for privacy and fraud prevention.
 * Preserves initial chars (manufacturer identifier) and last 4 chars, masking the middle.
 */
export function maskVin(vin) {
  if (!vin || typeof vin !== 'string') return vin;
  const trimmed = vin.trim();
  if (trimmed.length <= 4) return '****';
  if (trimmed.length <= 8) {
    return `${trimmed.slice(0, 2)}****${trimmed.slice(-2)}`;
  }
  const prefixLen = Math.min(6, Math.max(3, Math.floor(trimmed.length / 3) + 1));
  const suffixLen = 4;
  const maskedCount = Math.max(3, trimmed.length - prefixLen - suffixLen);
  return `${trimmed.slice(0, prefixLen)}${'*'.repeat(maskedCount)}${trimmed.slice(-suffixLen)}`;
}
